import axios from "axios";
import Config from "../../../config/index";

import {
  GET_QUARANTINE_DOWNLOAD_FAILURE,
  GET_QUARANTINE_DOWNLOAD_REQUEST,
  GET_QUARANTINE_DOWNLOAD_SUCCESS,
  GET_QUARATINE_REPORT_FAILURE,
  GET_QUARATINE_REPORT_REQUEST,
  GET_QUARATINE_REPORT_SUCCESS,
} from "./quaratineReportTypes";
let baseUrl = Config.baseUrl;

let baseUrlReport = Config.baseUrlReport;

const getQuarantineReportRequest = () => {
  return {
    type: GET_QUARATINE_REPORT_REQUEST,
  };
};

const getQuarantineReportSuccess = (payload) => {
  return {
    type: GET_QUARATINE_REPORT_SUCCESS,
    payload: payload,
  };
};

const getQuarantineReportFailure = (error) => {
  return {
    type: GET_QUARATINE_REPORT_FAILURE,
    payload: error,
  };
};

const getQuarantineReport = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getQuarantineReportRequest());
    let url = `${baseUrlReport}/quarantine?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&startDate=""&endDate=""`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getQuarantineReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getQuarantineReportFailure(err.response));
      });
  };
};

const downloadQuarantineReportRequest = () => {
  return {
    type: GET_QUARANTINE_DOWNLOAD_REQUEST,
  };
};

const downloadQuarantineReportSuccess = (payload) => {
  return {
    type: GET_QUARANTINE_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const downloadQuarantineReportFailure = (error) => {
  return {
    type: GET_QUARANTINE_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const downloadQuarantineReport = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadQuarantineReportRequest());
    let url = `${baseUrlReport}/quarantine?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadQuarantineReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadQuarantineReportFailure(err.response));
      });
  };
};

export { getQuarantineReport, downloadQuarantineReport };
